import { motion } from "framer-motion";
import { Reveal, fadeUp } from "@/lib/motion";

const SHOTS = [
    { src: "/images/onset-03.webp", span: "md:col-span-5", aspect: "3 / 4", caption: "Set 01 — Crew, exterior day" },
    { src: "/images/onset-02.webp", span: "md:col-span-7", aspect: "4 / 3", caption: "Set 02 — Calling the take" },
    { src: "/images/onset-01.webp", span: "md:col-span-6", aspect: "3 / 4", caption: "Set 03 — Between setups" },
    { src: "/images/onset-04.webp", span: "md:col-span-6", aspect: "3 / 4", caption: "Set 04 — Monitor village" },
];

export default function OnSet({ onOpen }) {
    return (
        <section data-testid="onset" className="px-5 md:px-10 pb-24 md:pb-32">
            <Reveal>
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-line pb-6">
                    <div>
                        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-inkdim">Behind the lens</p>
                        <h2 className="mt-4 font-display font-extrabold uppercase tracking-[-0.02em] leading-[0.95] text-3xl md:text-5xl">
                            On set <em className="font-serif italic font-medium normal-case">— where the work gets made.</em>
                        </h2>
                    </div>
                    <p className="text-sm text-inkdim max-w-xs leading-relaxed">
                        No stock photos here — these are mine. Real sets, real rigs, real days.
                    </p>
                </div>
            </Reveal>

            <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.05 }}
                className="mt-14 grid grid-cols-12 gap-6 md:gap-8"
            >
                {SHOTS.map((s, i) => (
                    <motion.div key={s.src} variants={fadeUp} className={`group col-span-12 ${s.span}`}>
                        <button
                            data-testid={`onset-photo-${i + 1}`}
                            onClick={() => onOpen({ title: s.caption, thumbnail_url: s.src, client: "Behind the lens", category: "" })}
                            className="block w-full text-left cursor-pointer"
                        >
                            <div className="relative overflow-hidden bg-surface" style={{ aspectRatio: s.aspect }}>
                                <img
                                    src={s.src}
                                    alt={s.caption}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <div className="absolute top-4 left-4 text-[10px] font-bold tracking-[0.2em] text-white mix-blend-difference">
                                    BTS {String(i + 1).padStart(2, "0")}
                                </div>
                            </div>
                            <p className="pt-4 text-[11px] uppercase tracking-[0.16em] text-inkdim">{s.caption}</p>
                        </button>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
}
